module.exports = __webpack_public_path__ + "img/Lendio-Ad-button.385ab9fa.png";